/**
 * Product Thumb Image Error Handler Render
 *
 * Renders placeholder markup for broken linked-product thumbnail images.
 */

import { Roles } from "../../../constants/roles";
import { ProductThumbImageErrorHandlerForm } from "./product-thumb-image-error-handler-form";
import {
    resolveCategorySymbol,
    buildCategoryPlaceholderHtml,
} from "../../../components/category-icon/resolve-category-symbol";

class ProductThumbImageErrorHandlerRender {
    private readonly form: ProductThumbImageErrorHandlerForm;

    public constructor() {
        this.form = new ProductThumbImageErrorHandlerForm();
    }

    public createNoImagePlaceholderHTML(categoryId: string | null = null): string {
        const symbol = resolveCategorySymbol(categoryId, (s) => this.form.hasCategoryIconSymbol(s));

        return `
            <div class="board-placeholder post-product-linker__thumb-placeholder"
                 data-role="${Roles.POST_PRODUCT_THUMB_PLACEHOLDER}"
                 data-placeholder-variant="no-image">
                ${buildCategoryPlaceholderHtml(symbol)}
            </div>
        `.replace(/>\s+</g, "><").trim();
    }

    public replaceBrokenThumbImage(img: HTMLImageElement): void {
        const thumb = this.form.getThumb(img);
        if (!(thumb instanceof HTMLElement)) return;

        const existing = this.form.getPlaceholder(thumb);
        if (existing) {
            img.remove();
            return;
        }

        // Insert next to img (inside its parent, e.g. the thumb link anchor) before
        // removing it, so the placeholder ends up nested exactly where the source
        // template puts it for the "no image" case — not as a trailing sibling of
        // the (now-empty) anchor at the thumb level, which broke the card layout.
        img.insertAdjacentHTML("beforebegin", this.createNoImagePlaceholderHTML(this.form.getCategoryId(thumb)));
        img.remove();
    }
}

export { ProductThumbImageErrorHandlerRender };
